import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";

export const Dialog = ({ primaryBtnHandler, onClose, children }) => {
  return (
    <MainModal
      isOpen
      containerClassName="dialog"
      parentSelector=".revenue-categories"
      width={400}
      height="auto"
      headerCloseHandler={onClose}
      primaryButtonText="Yes"
      primaryButtonClass="primary"
      primaryBtnHandler={() => {
        primaryBtnHandler();
        onClose();
      }}
      secondaryBtnClass="secondary"
      secondaryBtnText="No"
      secondaryBtnHandler={onClose}
      onClose={onClose}
      isAdminPanel={false}
    >
      {children}
    </MainModal>
  );
};
